(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfp-alo-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sfp-alo-offer')) {
  customElements.define('sfp-alo-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.life = new AbortController();
      this.labels = JSON.parse(this.querySelector('[data-alo-labels]').textContent);
      this.form = this.querySelector('form[action*="/cart/add"]');
      if (!this.form) return;
      this.variantSelect = this.form.querySelector('select[name="id"]');
      this.variants = Array.from(this.variantSelect.options).filter(o => o.value).map(o => ({id:o.value,size:o.dataset.size,color:o.dataset.color,price:o.dataset.price,available:!o.disabled}));
      this.colors = this.querySelector('[data-color-select]');
      this.sizes = Array.from(this.querySelectorAll('[data-size-choice]'));
      this.primary = this.querySelector('[data-primary-add]');
      this.addLabel = this.querySelector('[data-add-label]').textContent;
      this.fitForm = this.querySelector('[data-alo-fit-form]');
      this.sticky = this.querySelector('[data-sticky]');
      const selected = this.variants.find(v => v.id === this.variantSelect.value && v.available);
      if (selected && this.colors) this.colors.value = selected.color;
      this.querySelector('[data-native-variant]').hidden = true;
      this.variantSelect.required = false;
      this.querySelector('[data-enhanced-variants]').hidden = false;
      this.querySelectorAll('[data-js-only]').forEach(node => node.hidden = false);
      this.addEventListener('change', event => {
        if (event.target === this.colors) this.refreshSizes(this.selectedSize);
        if (event.target.matches('[data-size-choice]')) this.selectSize(event.target.value);
        if (event.target.matches('[data-chart-select],[data-unit-select]')) this.updateGuide();
      }, {signal:this.life.signal});
      this.addEventListener('click', event => {
        if (event.target.closest('[data-apply-size]') && this.matchSize) {
          this.selectSize(this.matchSize);
          const radio = this.sizes.find(s => s.value === this.matchSize && !s.disabled);
          radio?.scrollIntoView({block:'center'}); radio?.focus({preventScroll:true});
        }
        if (event.target.closest('[data-sticky-add]')) this.submitFromSticky();
      }, {signal:this.life.signal});
      this.form.addEventListener('submit', event => this.addToCart(event), {signal:this.life.signal});
      this.fitForm?.addEventListener('submit', event => {event.preventDefault();this.calculate();}, {signal:this.life.signal});
      this.fitForm?.addEventListener('input', () => this.resetResult(), {signal:this.life.signal});
      this.refreshSizes(selected?.size);
      this.updateGuide();
      if (this.sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {this.sticky.hidden = entries[0].isIntersecting;},{threshold:0.5});
        this.observer.observe(this.primary);
      }
    }
    disconnectedCallback() {this.life?.abort();this.observer?.disconnect();this.initialized=false;}
    text(key, values={}) {
      let value = this.labels[key] || '';
      Object.entries(values).forEach(([k,v]) => {value=value.replaceAll('['+k+']',v);});
      return value;
    }
    currentColor() {return this.colors?.value || '';}
    variantFor(size) {return this.variants.find(v=>v.color===this.currentColor() && v.size===size && v.available);}
    refreshSizes(size) {
      this.sizes.forEach(input => {input.disabled=!this.variantFor(input.value);input.checked=false;});
      this.selectSize(this.variantFor(size) ? size : '');
    }
    selectSize(size) {
      const variant = this.variantFor(size);
      this.selectedSize = variant?.size || '';
      const colorMedia=this.querySelectorAll('[data-alo-color-media]');
      colorMedia.forEach(node=>node.hidden=node.dataset.aloColorMedia!==this.currentColor());
      if(colorMedia.length) {
        const note=this.querySelector('[data-photo-note]');
        note.textContent=note.dataset.template.replace('[color]',this.currentColor());
      }
      this.variantSelect.value = variant?.id || '';
      this.sizes.forEach(input => {input.checked=!!variant && input.value===variant.size;});
      const priceVariant = variant || this.variants.find(v => v.color===this.currentColor() && v.available);
      if (priceVariant) this.querySelectorAll('[data-offer-price]').forEach(node=>node.textContent=priceVariant.price);
      this.querySelector('[data-selection-note]').textContent = variant ? this.text('selected',{color:variant.color,size:variant.size}) : this.text('choose_variant');
      this.primary.disabled = this.dataset.canOrder!=='true' || !this.variants.some(v=>v.color===this.currentColor() && v.available);
      const stickyButton = this.querySelector('[data-sticky-add]');
      if (stickyButton) {
        stickyButton.disabled=this.primary.disabled;
        stickyButton.textContent=variant?stickyButton.dataset.add+' · '+variant.size:stickyButton.dataset.choose;
      }
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
      window.history.replaceState({},'',url);
      this.variantSelect.dispatchEvent(new Event('change',{bubbles:true}));
      this.updateApply();
    }
    submitFromSticky() {
      if (this.variantSelect.value) this.form.requestSubmit();
      else this.focusSize();
    }
    focusSize() {
      const input=this.sizes.find(s=>!s.disabled);
      input?.scrollIntoView({block:'center'});input?.focus({preventScroll:true});
      this.querySelector('[data-selection-note]').textContent=this.text('choose_variant');
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.pending) return;
      const variant=this.variants.find(v=>v.id===this.variantSelect.value && v.available);
      if (!variant) {this.focusSize();return;}
      this.pending=true;this.primary.disabled=true;
      this.querySelector('[data-add-label]').textContent=this.text('adding');
      const message=this.querySelector('[data-cart-message]');
      message.hidden=true;this.querySelector('[data-view-cart]').hidden=true;
      const payload=new FormData(this.form);
      payload.delete('alo_size');
      try {
        const response=await fetch(this.form.action+'.js',{method:'POST',headers:{Accept:'application/json'},body:payload});
        const data=await response.json();
        if (!response.ok) throw new Error(typeof data.description==='string'?data.description:this.text('cart_error'));
        message.textContent=this.text('added',{selection:variant.color+' / '+variant.size});
        message.hidden=false;this.querySelector('[data-view-cart]').hidden=false;
        const cartUrl=new URL(this.querySelector('[data-cart-link]').href);
        cartUrl.pathname += '.js';
        try {
          const cartResponse=await fetch(cartUrl,{headers:{Accept:'application/json'}});
          if (cartResponse.ok) {const cart=await cartResponse.json();this.querySelector('[data-cart-count]').textContent=cart.item_count;}
        } catch {}
      } catch (error) {message.textContent=error.message || this.text('cart_error');message.hidden=false;}
      finally {this.pending=false;this.primary.disabled=false;this.querySelector('[data-add-label]').textContent=this.addLabel;}
    }
    resetResult() {this.matchSize=null;this.querySelector('[data-fit-result]').hidden=true;}
    updateGuide() {
      if (!this.fitForm) return;
      const chart=this.querySelector('[data-chart-select]').value;
      const unit=this.querySelector('[data-unit-select]').value;
      this.querySelectorAll('[data-chart-panel]').forEach(panel => {panel.hidden=panel.dataset.chartPanel!==chart;});
      this.querySelectorAll('[data-range]').forEach(cell => {
        const values=cell.dataset.range.split(',').map(Number);
        cell.textContent=values.map(v=>unit==='cm'?Number((v*2.54).toFixed(1)):v).join('–');
      });
      this.querySelectorAll('[data-unit-name]').forEach(node=>node.textContent=unit);
      this.querySelector('[data-hips-wrap]').hidden=chart==='men';
      this.querySelector('[data-measure="hips"]').disabled=chart==='men';
      if (this.previousUnit && unit!==this.previousUnit) {
        this.querySelectorAll('[data-measure]').forEach(input=>{if(input.value) input.value=Number((Number(input.value)*(unit==='cm'?2.54:1/2.54)).toFixed(1));});
      }
      this.previousUnit=unit;this.resetResult();
    }
    rangeMatch(value, ranges) {
      if (value<ranges[0][0] || value>ranges[ranges.length-1][1]) return null;
      let index=ranges.findIndex(range=>value<=range[1]);
      if (index<ranges.length-1 && value===ranges[index+1][0]) index++;
      return {index,boundary:value<ranges[index][0] || value===ranges[index][0] || value===ranges[index][1]};
    }
    calculate() {
      const chart=this.querySelector('[data-chart-select]').value;
      const unit=this.querySelector('[data-unit-select]').value;
      const data=JSON.parse(this.querySelector('[data-alo-chart-data]').textContent)[chart];
      const values={}; let invalid=false;
      this.querySelectorAll('[data-measure]').forEach(input=>{
        if (input.disabled) return;
        const value=Number(input.value)/(unit==='cm'?2.54:1);
        if (!input.value || !Number.isFinite(value) || value<=0) invalid=true;
        values[input.dataset.measure]=Number(value.toFixed(2));
      });
      const result=this.querySelector('[data-fit-result]');
      const headline=result.querySelector('strong');
      const note=result.querySelector('[data-fit-detail]');
      this.matchSize=null;headline.textContent='';note.textContent='';result.hidden=false;
      if (invalid) {headline.textContent=this.text('invalid_measurements');this.updateApply();return;}
      const top=this.rangeMatch(values.chest,data.chest);
      const waist=this.rangeMatch(values.waist,data.waist);
      const hips=chart==='women'?this.rangeMatch(values.hips,data.hips):waist;
      if (!top || !waist || !hips) {headline.textContent=this.text('out_of_range');this.updateApply();return;}
      const bottomIndex=Math.max(waist.index,hips.index);
      const topSize=data.sizes[top.index],bottomSize=data.sizes[bottomIndex];
      headline.textContent=this.text('chart_result',{top:topSize,bottom:bottomSize});
      if (top.index!==bottomIndex) note.textContent=this.text('different_sizes');
      else {
        this.matchSize=topSize;
        if(top.boundary || waist.boundary || hips.boundary) note.textContent=this.text('between');
      }
      this.updateApply();
    }
    updateApply() {
      const apply=this.querySelector('[data-apply-size]');
      if (!apply) return;
      const status=this.querySelector('[data-fit-availability]');
      apply.hidden=true;status.textContent='';
      if (!this.matchSize) return;
      const values={size:this.matchSize,color:this.currentColor()};
      const available=!!this.variantFor(this.matchSize);
      status.textContent=this.text(available?'chart_available':'size_unavailable',values);
      apply.textContent=this.text('apply_size',values);apply.hidden=!available;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfp-one-offer"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sfp-one-offer')) {
  customElements.define('sfp-one-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.purchaseForm = this.querySelector('form[action*="/cart/add"]');
      this.sticky = this.querySelector('[data-sticky]');
      this.sizingForm = this.querySelector('[data-sizing-form]');
      this.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.updateSelection(event.target);
      }, {signal:this.abort.signal});
      this.addEventListener('click', event => {
        if (event.target.closest('[data-apply-size]')) this.applySize();
        if (event.target.closest('[data-sticky-add]')) {
          const selected = this.purchaseForm.querySelector('input[name="id"]:checked');
          if (selected) this.purchaseForm.requestSubmit();
          else {
            const size = this.purchaseForm.querySelector('input[name="id"]:not(:disabled)');
            size?.scrollIntoView({block:'center'});
            size?.focus({preventScroll:true});
          }
        }
        const link = event.target.closest('a[href^="#"]');
        if (link) {
          const target = document.getElementById(link.hash.slice(1));
          if (target?.tagName === 'DETAILS') target.open = true;
        }
      }, {signal:this.abort.signal});
      this.sizingForm?.addEventListener('submit', event => { event.preventDefault(); this.calculate(); }, {signal:this.abort.signal});
      this.sizingForm?.addEventListener('input', () => {
        this.querySelector('[data-size-result]').hidden = true;
        this.querySelector('[data-size-error]').hidden = true;
        this.querySelector('[data-weight]')?.removeAttribute('aria-invalid');
      }, {signal:this.abort.signal});
      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      const deepLink = Array.from(this.querySelectorAll('input[name="id"][data-size]')).find(input => input.value === urlVariant && !input.disabled);
      if (deepLink) { deepLink.checked = true; this.updateSelection(deepLink); }
      if (this.sticky) {
        const primary = this.querySelector('[data-primary-add]');
        this.observer = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0.5});
        this.observer.observe(primary);
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.initialized = false; }
    updateSelection(input) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant',input.value);
      window.history.replaceState({},'',url);
      this.querySelectorAll('[data-offer-price]').forEach(node => node.textContent = input.dataset.price);
      const stickyButton = this.querySelector('[data-sticky-add]');
      if (stickyButton) stickyButton.textContent = stickyButton.dataset.add + ' · ' + input.dataset.size;
    }
    calculate() {
      if (this.dataset.profile === 'alo') { this.calculateAlo(); return; }
      const weightField = this.querySelector('[data-weight]');
      const weight = Number(weightField.value);
      const feet = Number(this.querySelector('[data-feet]').value);
      const inches = Number(this.querySelector('[data-inches]').value);
      const fit = this.querySelector('[data-fit]').value;
      const error = this.querySelector('[data-size-error]');
      if (!weightField.value || !Number.isInteger(weight) || weight < 80 || weight > 400) {
        error.hidden = false;
        weightField.setAttribute('aria-invalid','true');
        weightField.focus();
        this.querySelector('[data-size-result]').hidden = true;
        return;
      }
      error.hidden = true;
      weightField.removeAttribute('aria-invalid');
      let index = weight < 120 ? 0 : weight < 140 ? 1 : weight < 160 ? 2 : weight < 180 ? 3 : weight < 205 ? 4 : weight < 230 ? 5 : 6;
      if (feet * 12 + inches >= 74) index = Math.min(6,index + 1);
      if (fit === 'regular' || fit === 'fitted') index = Math.max(0,index - 1);
      const size = ['XXS','XS','S','M','L','XL','2XL'][index];
      const result = this.querySelector('[data-size-result]');
      result.dataset.size = size;
      result.querySelector('[data-recommended-size]').textContent = size;
      const fitNote = this.querySelector('[data-fit-note]');
      fitNote.textContent = this.querySelector('[data-fit]').selectedOptions[0].dataset.note;
      const variant = this.findSize(size);
      const apply = this.querySelector('[data-apply-size]');
      apply.hidden = !variant;
      apply.textContent = apply.dataset.label.replace('[size]',size);
      this.querySelector('[data-size-unavailable]').hidden = !!variant;
      result.hidden = false;
    }
    calculateAlo() {
      const top = this.querySelector('[data-alo-top]').value;
      const bottom = this.querySelector('[data-alo-bottom]').value;
      const result = this.querySelector('[data-size-result]');
      const error = this.querySelector('[data-size-error]');
      result.hidden = true;
      error.hidden = false;
      if (!top || !bottom) { error.textContent = error.dataset.empty; return; }
      if (top === 'unsure' || bottom === 'unsure') { error.textContent = error.dataset.unsure; return; }
      if (top !== bottom) { error.textContent = error.dataset.mismatch; return; }
      error.hidden = true;
      result.dataset.size = top;
      result.querySelector('[data-recommended-size]').textContent = top;
      this.querySelector('[data-fit-note]').textContent = result.dataset.aloNote;
      const variant = this.findSize(top);
      const apply = this.querySelector('[data-apply-size]');
      apply.hidden = !variant;
      apply.textContent = apply.dataset.label.replace('[size]', top);
      this.querySelector('[data-size-unavailable]').hidden = !!variant;
      result.hidden = false;
    }
    findSize(size) {
      const aliases = { XXSMALL: 'XXS', EXTRAEXTRASMALL: 'XXS', XSMALL: 'XS', EXTRASMALL: 'XS', SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XLARGE: 'XL', EXTRALARGE: 'XL', XXL: '2XL', XXLARGE: '2XL', EXTRAEXTRALARGE: '2XL' };
      const canonical = value => {
        const key = String(value ?? '').trim().toUpperCase().replace(/[\s_-]+/g, '');
        return aliases[key] || key;
      };
      return Array.from(this.querySelectorAll('input[name="id"][data-size]')).find(input => canonical(input.dataset.size) === canonical(size) && !input.disabled);
    }
    applySize() {
      const size = this.querySelector('[data-size-result]').dataset.size;
      const variant = this.findSize(size);
      if (!variant) return;
      variant.checked = true;
      variant.dispatchEvent(new Event('change',{bubbles:true}));
      variant.scrollIntoView({block:'center'});
      variant.focus({preventScroll:true});
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sfp-wholesale"] && !Shopify.designMode) return;
  try {
    
function setupWholesale(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('form'),sticky=root.querySelector('[data-mobile-cta]'),heroButton=root.querySelector('.sfpw-hero .sfpw-button'),request=root.querySelector('[data-wholesale-request]');
 if(sticky&&heroButton&&request&&'IntersectionObserver' in window){
  let heroVisible=true,requestVisible=false,keyboardOpen=false;
  const updateSticky=()=>{const requestReached=request.getBoundingClientRect().top<=window.innerHeight*.85;sticky.hidden=heroVisible||requestVisible||requestReached||keyboardOpen;};
  new IntersectionObserver(entries=>{heroVisible=entries[0].isIntersecting;updateSticky();},{threshold:.05}).observe(heroButton);
  new IntersectionObserver(entries=>{requestVisible=entries[0].isIntersecting;updateSticky();},{threshold:.05}).observe(request);
  if(window.visualViewport){window.visualViewport.addEventListener('resize',()=>{keyboardOpen=window.visualViewport.height<window.innerHeight*.75;updateSticky();});}
  updateSticky();
 }
 if(!form)return;
 const first=form.querySelector('[data-step="1"]'),second=form.querySelector('[data-step="2"]');
 if(first&&second){
  const next=form.querySelector('[data-next]'),back=form.querySelector('[data-back]');next.hidden=false;back.hidden=false;second.hidden=true;
  const validFirst=()=>Array.from(first.querySelectorAll('input,select')).every(el=>el.reportValidity());
  next.addEventListener('click',()=>{if(validFirst()){first.hidden=true;second.hidden=false;second.querySelector('input').focus();}});
  back.addEventListener('click',()=>{second.hidden=true;first.hidden=false;first.querySelector('input').focus();});
  form.addEventListener('invalid',event=>{if(first.contains(event.target)){first.hidden=false;second.hidden=true;}else if(second.contains(event.target)){first.hidden=true;second.hidden=false;}},true);

 }
}
document.querySelectorAll('[data-wholesale]').forEach(setupWholesale);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-wholesale]').forEach(setupWholesale));

  } catch(e) { console.error(e); }
})();
})();
